// extracted by mini-css-extract-plugin
module.exports = {"cont":"LayoutMobileSidebar_cont__b0mTy","title":"LayoutMobileSidebar_title__1vF0I","menu":"LayoutMobileSidebar_menu__3A5nm"};